import Vue from 'vue'
import bhUi from '../../components/bh-ui'
let u = navigator.userAgent
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

// let iosNode
// if (isiOS) {
//     iosNode = document.createElement('div')
//     iosNode.id = 'title'
//     iosNode.style.display = 'none'
// }

const native = {
    isiOS: isiOS,
    backNative() {
        console.log('返回')
    },
    login(mobile, verifyCode) {
        try {
            if (isiOS) {
                window.webkit.messageHandlers.login.postMessage([mobile, verifyCode])
            } else {
                window.native.login(mobile, verifyCode)
            }
        } catch (e) {
            console.log(e)
        }
    },
    exit() {
        // console.log(native)
        try {
            if (isiOS) {
                // window.exit()
                window.webkit.messageHandlers.exit.postMessage(null)
            } else {
                window.native.exit()
            }
            // window.native.exit()
        } catch (e) {
            history.back()
            console.log(e)
        }

    },
    contactCustomerService() {
        try {
            if (isiOS) {
                // window.contactCustomerService()
                window.webkit.messageHandlers.contactCustomerService.postMessage(null)
            } else {
                window.native.contactCustomerService()
            }
        } catch (e) {
            console.log(e)
        }
    },
    saveImg(url) {
        try {
            if (isiOS) {
                window.webkit.messageHandlers.saveImg.postMessage(url)
            } else {
                window.native.saveImg(url)
            }
        } catch (e) {
            console.log(e)
        }
    },
    readQrImg(url) {
        try {
            if (isiOS) {
                window.webkit.messageHandlers.readQrImg.postMessage(url)
            } else {
                window.native.readQrImg(url)
            }
        } catch (e) {
            console.log(e)
        }
    },
    sendBase64(url) {
        try {
            if (isiOS) {
                window.webkit.messageHandlers.sendBase64.postMessage(url)
            } else {
                window.native.sendBase64(url)
            }
        } catch (e) {
            console.log(e)
        }
    },
    changeBarColor(color) {
        try {
            if (isiOS) {
                window.webkit.messageHandlers.changeBarColor.postMessage(color)
            } else {
                window.native.changeBarColor(color)
            }
        } catch (e) {
            console.log(e)
        }
        window.nativeThen = function(res) {
            if(typeof res == "string") {
                res = JSON.parse(res)
            }
            if (res.code == 200) {
                //
            }
            window.nativeThen = null
        }
    },
    saveBase64Img(url) {
        try {
            if (isiOS) {
                // iosNode.innerHtml = url
                // window.saveBase64Img(url)
                window.webkit.messageHandlers.saveBase64Img.postMessage(url)
            } else {
                window.native.saveBase64Img(url)
            }
            bhUi.Toast({text: '图片已保存，请去相册查看'})
            // window.native.saveBase64Img(url)
        } catch (e) {
            console.log(e)
        }
        window.nativeThen = function(res) {
            if(typeof res == "string") {
                res = JSON.parse(res)
            }
            if (res.code == 200) {
                //
            }
            window.nativeThen = null
        }
    },
    sendInvitationLink(data) {
        try {
            if (isiOS) {
                window.webkit.messageHandlers.sendInvitationLink.postMessage([data.title, data.remark, data.url])
            } else {
                window.native.sendInvitationLink(data.title, data.remark, data.url)
            }
            return true
        } catch (e) {
            try {
                if (isiOS) {
                    window.webkit.messageHandlers.sendInvitationLink.postMessage([data.title, data.remark, data.url, 1])
                } else {
                    window.native.sendInvitationLink(data.title, data.remark, data.url, 1)
                }
                return true
            } catch (e) {
                console.log(1)
                return true
            }
        }
    },
    // 原生调用js
    toats(text) {
        alert(text)
    },
    toThisLink(url) {
        location.href = url
    },
    getLoginMsg(data){
        console.log(data)
    },
    install() {
      Vue.prototype.$native = native
    }
}

// window.native = native



export default native
